module.exports = "//static.hsappstatic.net/LoginUI/static-1.15094/img/apple-logo.png"